import { useEffect } from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';
import { IllustrationView, SomethingWentWrongIllustration } from 'modules/shared/features/illustration';

const ErrorBoundary = () => {
    const error: any = useRouteError();
    const navigate = useNavigate();

    useEffect(() => {
        if (import.meta.env.VITE_APP_ENVIRONMENT === 'staging') {
            // Log error to console
            console.log({ message: error.message, stack: error.stack });
        } else {
            // Log error to server
            console.log({ message: error.message, stack: error.stack });
            // http.post(`${getApiUrl()}/api/v1/agent/errors`, {
            //     message: error.message,
            //     stack: error.stack,
            //     path: window.location.pathname,
            //     platform: 'WEB',
            // }).catch(() => {});
        }
    }, [error]);

    return (
        <IllustrationView
            className="mt-[18vh]"
            illustration={<SomethingWentWrongIllustration />}
            title="Oops, something went wrong"
            message={
                <>
                    An error occurred while processing your request. Please try again.
                    <div className="mt-1">
                        <a
                            className="text-primary font-medium cursor-pointer"
                            onClick={() => navigate('/', { replace: true })}
                        >
                            Go back home
                        </a>
                    </div>
                </>
            }
        />
    );
};

export default ErrorBoundary;
